// extracted by mini-css-extract-plugin
export default {"contentCenter":"Spinner_contentCenter__xizBI","root":"Spinner_root__S0N6l"};